export const isGameAvailableInUserCountry = (
    game: { restrictedCountries?: string[] | null } | null | undefined,
    userCountry: string | null,
): boolean => {
    if (!game) return false;
    if (!userCountry) return true;
    const restricted = game.restrictedCountries;
    if (!restricted || restricted.length === 0) return true;
    return !restricted.includes(userCountry.toUpperCase());
};
